/**
 * Initialize Choices.js with AJAX search on a select element.
 * Defined at module level so it is available immediately (not deferred to DOM ready).
 * @param {HTMLSelectElement} selectEl
 * @param {string} searchBaseUrl  URL ending with 'q=' — query string is appended
 * @returns {Choices|null}
 */
window.initChoicesAjaxSearch = function (selectEl, searchBaseUrl, preload) {
    if (!selectEl || !window.Choices) return null;

    if (selectEl._choicesSearchHandler) {
        selectEl.removeEventListener('search', selectEl._choicesSearchHandler);
        delete selectEl._choicesSearchHandler;
    }

    var instance = new window.Choices(selectEl, {
        itemSelectText: '',
        allowHTML: false,
        searchResultLimit: 100,
        searchFloor: 1,
        shouldSort: false,
        searchEnabled: true,
        // With preload the empty "prompt" choice is replaced by the fetched list, so
        // offer a clear (×) button to return to the empty/default selection.
        removeItemButton: !!preload,
    });

    function applyResults(results) {
        if (!instance) return;
        instance.clearChoices();
        instance.setChoices(results, 'value', 'label');
    }

    function fetchResults(q, cb) {
        fetch(searchBaseUrl + encodeURIComponent(q))
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (data.status !== 'success') return;
                var results = (data.data && Array.isArray(data.data.results)) ? data.data.results : [];
                cb(results);
            })
            .catch(function () {});
    }

    // The first-100 default set, fetched once and reused so clearing the search
    // box restores it without another request.
    var defaultResults = null;
    function loadDefault() {
        if (defaultResults) { applyResults(defaultResults); return; }
        fetchResults('', function (results) {
            defaultResults = results;
            applyResults(results);
        });
    }

    var searchTimeout = null;
    function searchHandler(e) {
        clearTimeout(searchTimeout);
        var q = e.detail.value;
        searchTimeout = setTimeout(function () {
            fetchResults(q, applyResults);
        }, 300);
    }

    selectEl._choicesSearchHandler = searchHandler;
    selectEl.addEventListener('search', searchHandler);

    if (preload) {
        // Preload the first 100 so short lists are pickable without typing, and
        // restore them whenever the search box is cleared back to empty (Choices
        // does not fire 'search' on an empty query).
        loadDefault();
        if (instance.input && instance.input.element) {
            instance.input.element.addEventListener('input', function (ev) {
                if (!ev.target.value) {
                    clearTimeout(searchTimeout);
                    loadDefault();
                }
            });
        }
    }

    return instance;
};

$(function () {

    window.initDynamicContent = function (container) {
        var $container = container ? $(container) : $(document);

        if (typeof window.feather !== 'undefined' && typeof window.feather.replace === 'function') {
            window.feather.replace();
        }

        $container.find('[data-bs-toggle="tooltip"]').each(function () {
            bootstrap.Tooltip.getOrCreateInstance(this);
        });

        $container.find('[data-bs-toggle="popover"]').each(function () {
            bootstrap.Popover.getOrCreateInstance(this);
        });
    };

    $(document).ajaxStart(function () {
        Pace.restart();
    });

    $(document).ready(function () {
        // $('.rotate').css('height', $('.rotate').width());
    });

    function loadHtmlContent(url) {
        var content = '';
        $.ajax({
            type: 'POST', url: url, async: false, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    content = data.data.content;
                } else {
                    bootbox.alert(data.msg);
                    return false;
                }
            },
            error: function (data) {
                bootbox.alert(data);
            }
        });
        return content;
    }

    $(document).on('click', '.common_file_preview_button', function (e) {
        e.preventDefault();
        var uuid = $(this).data('file_uuid');
        var url = $('#commonFilePreviewModal').data('load_preview_url');
        if (uuid.length < 36) {
            return false;
        }
        if (url.length < 10) {
            return false;
        }
        console.log(uuid);
        console.log(url);
        $.ajax({
            type: 'POST', url: url + uuid, async: false, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    $('#commonFilePreviewModalBody').html(data.data.content);
                    $('#commonFilePreviewModal').modal('show');
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                console.log(data);
                bootbox.alert('Chyba při provádění operace<br><br>' + data.responseJSON.msg);
            }
        });
    });

    $(document).on('click', '.invoice_file_preview_button', function (e) {
        var uuid = $(this).data('invoice_uuid');
        var url = $('#commonFilePreviewModal').data('load_preview_url');
        if (uuid.length < 36) {
            return false;
        }
        if (url.length < 10) {
            return false;
        }
        console.log(uuid);
        console.log(url);
        $.ajax({
            type: 'POST', url: url + uuid + '&type=invoice', async: false, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    $('#commonFilePreviewModalBody').html(data.data.content);
                    $('#commonFilePreviewModal').modal('show');
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                console.log(data);
                bootbox.alert('Chyba při provádění operace<br><br>' + data.responseJSON.msg);
            }
        });
    });

    $(document).on('shown.bs.tab', 'a[data-bs-toggle="tab"][data-ajax_url]', function (e) {
        if ($(this).closest('#taskDetailTab').length > 0) {
            return;
        }

        var ajax_url = $(this).data('ajax_url');
        if (typeof ajax_url !== "undefined") {
            var dest_id = $(this).attr('aria-controls');
            $.ajax({
                type: 'POST', url: ajax_url, async: false, dataType: 'json',
                success: function (data) {
                    if (data.status == 'success') {
                        //console.log(data);
                        $('#' + dest_id).html(data.data.content);
                        if (typeof window.initDynamicContent === 'function') {
                            window.initDynamicContent($('#' + dest_id));
                        }
                    } else {
                        bootbox.alert(data.msg);
                    }
                },
                error: function (data) { // if error occured
                    bootbox.alert('Chyba při provádění operace');
                }
            });
        }
    });

    $(document).on('click', '.responsibility-edit', function (e) {
        e.preventDefault();
        $('#responsibility_id_edit').val($(this).data('responsibility_id'));
        if ($(this).data('is_key_person') == '1') {
            $('#is_key_person_edit').prop('checked', true);
        } else {
            $('#is_key_person_edit').prop('checked', false);
        }
        $('#responsibilityEditModal').modal('show');
    });

    $(document).on('click', '#responsibility-edit-save', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var form_data = form.serialize();
        var refresh_url = $(this).data('table_url');
        var url = form.attr('action');
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Opravdu uložit změny v odpovědnosti pracovníka?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    $.ajax({
                        type: 'POST', url: url, data: form_data, async: false, dataType: 'json',
                        success: function (data) {
                            if (data.status == 'success') {
                                let content = loadHtmlContent(refresh_url);
                                $('#responsibilityTable').html(content);
                                $('#responsibilityEditModal').modal('hide');
                            } else {
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) { // if error occured
                            bootbox.alert(data);
                        }
                    });
                    return true;
                } else {
                    return true;
                }
            }
        });
    });

    $(document).on('click', '.responsibility-remove', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        var refresh_url = $(this).data('table_url');
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Opravdu odebrat odpovědnost pracovníkovi?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    $.ajax({
                        type: 'POST', url: url, async: false, dataType: 'json',
                        success: function (data) {
                            if (data.status == 'success') {
                                let content = loadHtmlContent(refresh_url);
                                $('#responsibilityTable').html(content);
                            } else {
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) { // if error occured
                            bootbox.alert(data);
                        }
                    });
                    return true;
                } else {
                    return true;
                }
            }
        });
    });

    $(document).on('click', '#save_responsibilities_list', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var form_data = form.serialize();
        var refresh_url = $(this).data('table_url');
        var url = form.attr('action');
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Opravdu uložit změny v odpovědnostech?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    $.ajax({
                        type: 'POST', url: url, data: form_data, async: false, dataType: 'json',
                        success: function (data) {
                            if (data.status == 'success') {
                                let content = loadHtmlContent(refresh_url);
                                $('#responsibilityTable').html(content);
                                $('#responsibilityAddModal').modal('hide');
                            } else {
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) { // if error occured
                            bootbox.alert(data);
                        }
                    });
                    return true;
                } else {
                    return true;
                }
            }
        });
    });

    $(document).on('click', '.add_responsibility_worker', function (e) {
        e.preventDefault();
        $('#responsibility_id').val($(this).data('responsibility_id'));
        $('#responsibilityAddPersonModal').modal('show');
    });

    $(document).on('click', '#save_responsibility_person', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var form_data = form.serialize();
        var url = form.attr('action');
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Opravdu přidat odpovědnost pracovníkovi?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    $.ajax({
                        type: 'POST', url: url, data: form_data, async: false, dataType: 'json',
                        success: function (data) {
                            if (data.status == 'success') {
                                document.location.reload();
                            } else {
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) { // if error occured
                            bootbox.alert(data);
                        }
                    });
                    return true;
                } else {
                    return true;
                }
            }
        });
    });

    $(document).on('click', '.show_competence_history', function (e) {
        var person_uuid = $(this).data('competence_person_uuid');
        var competence_id = $(this).data('competence_id');
        let content = loadHtmlContent($(this).data('history_url') + '?person_uuid=' + person_uuid + '&competence_id=' + competence_id);
        $('#competenceHistoryModalBody').html(content);
        return true;
    });

    $(document).on('click', '#set-all-notifications-as-read', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        $.when($.ajax({
            type: 'POST',
            url: url,
            async: false,
            cache: true,
            success: function (data) {
                console.log(data);
                $('#notifications-counter-badge').hide();
            },
            error: function (data) {
                bootbox.alert('Nepodařilo se vymazat notifikace');
            }, dataType: 'json'
        })).done(function (result) {
            return result;
        });
    });

    $(document).on('click', '.show_external_help', function (e) {
        let url = $(this).data('help_url');
        let api_url = $(this).data('api_url');
        console.log(api_url + url);
        fetch(api_url + url, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                console.log(data.data.content);
                const content = $('<div>').html(data.data.content);
                const documentContent = content.find('.document');
                documentContent.find('img').each(function() {
                    const currentSrc = $(this).attr('src');
                    $(this).attr('src', url + currentSrc);
                }).css('max-width', '100%');
                $('#offcanvas-help-body-content').html(documentContent.html());
                $('#offcanvas-help-external-url').prop('href', url);
            })
            .catch(error => {
                console.error('GET error:', error);
                bootbox.alert('Došlo k neočekávané chybě při zobrazení nápovědy.');
            });
    });

});

/**
 * Přesný geodetický převod souřadnic z ArcGIS RUIAN (S-JTSK) do WGS84 (GPS)
 *
 * @param {number} apiX Hodnota "x" z API (např. -671557.53) // JTSK Y
 * @param {number} apiY Hodnota "y" z API (např. -1082657.91) // JTSK X
 * @returns {object} Objekt obsahující {lat: number, lon: number}
 */
function cuzkToWgs84(apiX, apiY) {
    // 1. ZPRACOVÁNÍ VSTUPŮ
    const y = Math.abs(apiX);
    const x = Math.abs(apiY);

    // 2. KONSTANTY PRO KŘOVÁKOVO ZOBRAZENÍ
    const a = 6377397.15508;
    const e = 0.081696831215303;
    const n = 0.97992470462083;
    const konst_u_ro = 12310230.12797036;
    const sinUQ = 0.863499969506341;
    const cosUQ = 0.504348889819882;
    const sinVQ = 0.420215144586493;
    const cosVQ = 0.907424504992097;
    const alfa = 1.000597498371542;
    const k = 1.003419163966575;

    // 3. INVERZNÍ KŘOVÁKOVA PROJEKCE (Rovina -> Besselův elipsoid)
    const ro = Math.max(Math.sqrt(x * x + y * y), 0.01);
    const epsilon = 2 * Math.atan(y / (ro + x));
    const D = epsilon / n;

    // Šířka na Gaussově kouli
    const S = 2 * Math.atan(Math.exp((1 / n) * Math.log(konst_u_ro / ro))) - (Math.PI / 2);
    const sinS = Math.sin(S);
    const cosS = Math.cos(S);

    // Zpětný převod z koule
    const sinU = sinUQ * sinS - cosUQ * cosS * Math.cos(D);
    const cosU = Math.sqrt(1 - sinU * sinU);
    const sinDV = Math.sin(D) * cosS / cosU;
    const cosDV = Math.sqrt(1 - sinDV * sinDV);

    const sinV = sinVQ * cosDV - cosVQ * sinDV;
    const cosV = cosVQ * cosDV + sinVQ * sinDV;

    // Geografická délka na Besselově elipsoidu (od Greenwiche)
    const Ljtsk = 2 * Math.atan(sinV / (1 + cosV)) / alfa;

    // Iterativní výpočet šířky na Besselově elipsoidu
    const t = Math.exp((2 / alfa) * Math.log((1 + sinU) / (cosU * k)));
    let pom = (t - 1) / (t + 1);
    let sinB;

    do {
        sinB = pom;
        pom = t * Math.exp(e * Math.log((1 + e * sinB) / (1 - e * sinB)));
        pom = (pom - 1) / (pom + 1);
    } while (Math.abs(pom - sinB) > 1e-11);

    const Bjtsk = Math.asin(pom);

    // 4. PŘEVOD BESSELŮV ELIPSOID -> KARTÉZSKÉ SOUŘADNICE
    const H = 200; // Zvolená průměrná nadmořská výška v ČR
    const e2_bessel = e * e;
    const W = Math.sqrt(1 - e2_bessel * Math.sin(Bjtsk) * Math.sin(Bjtsk));
    const N = a / W;

    const X_bes = (N + H) * Math.cos(Bjtsk) * Math.cos(Ljtsk);
    const Y_bes = (N + H) * Math.cos(Bjtsk) * Math.sin(Ljtsk);
    const Z_bes = (N * (1 - e2_bessel) + H) * Math.sin(Bjtsk);

    // 5. HELMERTOVA 7-PARAMETRICKÁ TRANSFORMACE (Bessel -> WGS84)
    const dX = 570.8;
    const dY = 85.7;
    const dZ = 462.8;
    const rx = (4.998 / 3600) * (Math.PI / 180);
    const ry = (1.587 / 3600) * (Math.PI / 180);
    const rz = (5.261 / 3600) * (Math.PI / 180);
    const m = 3.56 / 1000000;

    const X_wgs = X_bes + dX + m * X_bes - rz * Y_bes + ry * Z_bes;
    const Y_wgs = Y_bes + dY + m * Y_bes + rz * X_bes - rx * Z_bes;
    const Z_wgs = Z_bes + dZ + m * Z_bes - ry * X_bes + rx * Y_bes;

    // 6. KARTÉZSKÉ SOUŘADNICE -> SOUŘADNICE WGS84 (Lat, Lon)
    const a_wgs = 6378137.0;
    const e2_wgs = 0.00669437999014;

    const L_wgs = Math.atan2(Y_wgs, X_wgs);
    const p = Math.sqrt(X_wgs * X_wgs + Y_wgs * Y_wgs);

    // Stabilní iterace
    let B_wgs = Math.atan2(Z_wgs, p * (1 - e2_wgs));
    for (let i = 0; i < 5; i++) {
        let sinBwgs = Math.sin(B_wgs);
        let N_wgs = a_wgs / Math.sqrt(1 - e2_wgs * sinBwgs * sinBwgs);
        B_wgs = Math.atan2(Z_wgs + e2_wgs * N_wgs * sinBwgs, p);
    }

    // Návratová hodnota zaokrouhlená na 7 desetinných míst
    return {
        lat: Number((B_wgs * 180 / Math.PI).toFixed(7)),
        lon: Number((L_wgs * 180 / Math.PI).toFixed(7))
    };
}
